import React, { useState } from 'react';
import { Checkbox } from 'common/checkbox';
import { classnames } from 'helpers/utils';
import { CheckDashIcon, PlusIcon } from 'assets/icons';
import styles from './prompt-categories-right-section.module.scss';

type CardProps = {
  title: string;
  imageSrc: string;
  questions: QuestionType[];
  selected: QuestionType[];
  toggleSelection: (question: QuestionType) => void;
};

const PrompCategorieRightSection: React.FC<CardProps> = ({
  title,
  imageSrc,
  questions,
  selected,
  toggleSelection,
}) => {
  const [visibleCount, setVisibleCount] = useState(3);

  const visibleQuestions = questions.slice(0, visibleCount);
  const hasMoreQuestions = questions.length > visibleCount;

  const handleToggleQuestions = () => {
    if (hasMoreQuestions) {
      setVisibleCount((prev) => Math.min(prev + 3, questions.length));
    } else {
      setVisibleCount(3);
    }
  };

  return (
    <div className={styles.card}>
      <img src={imageSrc} alt={title} className={styles.cardImage} />
      <div className={styles.content}>
        <span className="text__body__semi__bold__large__gray900">{title}</span>
        <div className={styles.cardOption}>
          {visibleQuestions.map((question) => (
            <div key={question.id} className={styles.questions}>
              <div className={styles.checkbox}>
                <Checkbox
                  itemKey={String(question.id ?? '')}
                  isChecked={selected.includes(question)}
                  onChange={() => toggleSelection(question)}
                />
              </div>
              <label
                htmlFor={String(question.id ?? '')}
                className="text__body__regular__medium__gray800"
              >
                {question.name}
              </label>
            </div>
          ))}
        </div>

        {questions.length > 3 && (
          <button
            type="button"
            className={classnames(
              styles.moreButton,
              'text__body__regular__medium__gray500',
            )}
            onClick={handleToggleQuestions}
          >
            {hasMoreQuestions ? <PlusIcon /> : <CheckDashIcon />}
            {hasMoreQuestions ? 'More' : 'Less'}
          </button>
        )}
      </div>
    </div>
  );
};

export { PrompCategorieRightSection };
